<template>
    <div class="modal__wrap" @click.stop="$emit('closeModal')">
        <div class="modal__con" @click.stop="">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: "BatchModal"
}
</script>

<style scoped>
.modal__wrap{
    z-index: 900;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.1);
}
.modal__con{
    position: absolute;
    background: #ffffff;
    border-radius: 5px;
    width: 600px;
    height: 400px;
    top: calc(50% - 300px);
    left: calc(50% - 200px);
    box-shadow: 0 0 15px 0 rgba(0,0,0,0.5);
}
</style>